import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 3 }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-center my-3 ml-3 mr-4 justify-space-between"
}
const _hoisted_3 = { class: "text-primary" }
const _hoisted_4 = {
  key: 2,
  class: "pa-2 d-flex align-center justify-center"
}
const _hoisted_5 = {
  key: 3,
  class: "pa-2 d-flex align-center justify-center"
}
const _hoisted_6 = { class: "d-flex justify-center align-center mt-2" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "d-flex justify-center" }
const _hoisted_9 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_10 = {
  key: 2,
  style: {"color":"red"}
}
const _hoisted_11 = { style: {"width":"80vw"} }
const _hoisted_12 = {
  class: "text-center",
  style: {"width":"750px"}
}
const _hoisted_13 = { style: {"width":"750px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_DeclarationManagerCheck = _resolveComponent("DeclarationManagerCheck")!
  const _component_DeclarationManagerInsee = _resolveComponent("DeclarationManagerInsee")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_TaxFormEDIReport = _resolveComponent("TaxFormEDIReport")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_DeclarationManagerInfo = _resolveComponent("DeclarationManagerInfo")!
  const _component_DeclarationManagerDeclaring = _resolveComponent("DeclarationManagerDeclaring")!
  const _component_TaxForm = _resolveComponent("TaxForm")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_btn_add_icon = _resolveComponent("v-btn-add-icon")!
  const _component_AccountingItemEdition = _resolveComponent("AccountingItemEdition")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!

  return (_ctx.companyId)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.isSubComponent ? 'pt-1 pr-3 pb-1 pl-1' : 'pa-3')
      }, [
        _createVNode(_component_v_row, {
          "no-gutters": "",
          class: "rounded-xl d-flex justify-center align-center mb-2 bg-white"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "6",
              class: "d-flex align-center"
            }, {
              default: _withCtx(() => [
                (_ctx.assistVatMode)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "mx-2",
                      "prepend-icon": "$fa-chevron-left",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back())),
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[44] || (_cache[44] = [
                        _createTextVNode("Assistant TVA")
                      ])),
                      _: 1
                    }))
                  : (_ctx.autoVatMode)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        class: "mx-2",
                        "prepend-icon": "$fa-chevron-left",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.back())),
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[45] || (_cache[45] = [
                          _createTextVNode("TVA automatique")
                        ])),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_btn_back, {
                        key: 2,
                        class: "mx-2",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.back()))
                      })),
                (_ctx.cerfaName)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(_ctx.cerfaName), 1))
                  : _createCommentVNode("", true),
                (!_ctx.showLeftPanel)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 4,
                      class: "ml-4",
                      size: "small",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showLeftPanel = true))
                    }, {
                      default: _withCtx(() => _cache[46] || (_cache[46] = [
                        _createTextVNode("Afficher le panneau latéral")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "6",
              class: "d-flex align-center justify-end px-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DeclarationManagerCheck, {
                  errorsCount: _ctx.errorsCount,
                  errorMessages: _ctx.errorMessages
                }, null, 8, ["errorsCount", "errorMessages"]),
                (_ctx.cerfaNumber === '2561')
                  ? (_openBlock(), _createBlock(_component_DeclarationManagerInsee, { key: 0 }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  rounded: "",
                  elevation: "0",
                  disabled: _ctx.isDisabledSaveButton,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.save())),
                  class: "mx-1",
                  size: "small"
                }, {
                  default: _withCtx(() => _cache[47] || (_cache[47] = [
                    _createTextVNode(" Enregistrer ")
                  ])),
                  _: 1
                }, 8, ["disabled"]),
                (_ctx.isTrainingOffer)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, { key: 1 }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps({
                          rounded: "",
                          elevation: "0",
                          dark: "",
                          size: "small",
                          disabled: true,
                          class: "mx-1"
                        }, props), {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.validAndPayTitle), 1)
                          ]),
                          _: 2
                        }, 1040)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("training-text.normal-text")), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_btn, {
                      key: 2,
                      rounded: "",
                      elevation: "0",
                      dark: "",
                      size: "small",
                      disabled: _ctx.isDisabledValidAndSendButton,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validAndPay())),
                      class: "mx-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.validAndPayTitle), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])),
                _createVNode(_component_v_btn, {
                  rounded: "",
                  elevation: "0",
                  disabled: _ctx.isDisabledValidButton,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmWithoutSendingDialog = true)),
                  class: "mx-1",
                  size: "small"
                }, {
                  default: _withCtx(() => _cache[48] || (_cache[48] = [
                    _createTextVNode(" Valider sans envoyer ")
                  ])),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_menu, { "offset-y": "" }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn_icon, _mergeProps({
                      size: "large",
                      icon: "$dots_vertical"
                    }, props, { class: "mx-1" }), null, 16)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, null, {
                      default: _withCtx(() => [
                        (!_ctx.isAccountingHidden)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 0,
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.confirmDialogMiscellaneousOperation = true)),
                              disabled: !_ctx.documentId && !_ctx.newDocumentId
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "small" }, {
                                  default: _withCtx(() => _cache[50] || (_cache[50] = [
                                    _createTextVNode("$oss-edit")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[49] || (_cache[49] = [
                                    _createTextVNode("Afficher / Modifier l'OD")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        (!_ctx.isAccountingHidden)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 1,
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.reComputeAccountingLines())),
                              disabled: !_ctx.isSent || _ctx.isInsideClosedAccountingPeriod
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "small" }, {
                                  default: _withCtx(() => _cache[52] || (_cache[52] = [
                                    _createTextVNode("$fa-redo-alt")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[51] || (_cache[51] = [
                                    _createTextVNode("Regénérer l'OD")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_list_item, {
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateStatus())),
                          disabled: !_ctx.isSent || _ctx.translatedStatus === 'Validée sans envoi'
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "small" }, {
                              default: _withCtx(() => _cache[54] || (_cache[54] = [
                                _createTextVNode("$fa-redo-alt")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[53] || (_cache[53] = [
                                _createTextVNode("Mettre à jour le statut")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        (_ctx.cerfaNumber === '2561')
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 2,
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.printForms()))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "small" }, {
                                  default: _withCtx(() => _cache[56] || (_cache[56] = [
                                    _createTextVNode("$oss-download")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[55] || (_cache[55] = [
                                    _createTextVNode("Imprimer les formulaires 2561TER")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_TaxFormEDIReport, {
                          disabled: !_ctx.mtaeId,
                          taxFormId: _ctx.declarationId,
                          isDeclaration: true
                        }, {
                          default: _withCtx(({ statusOk, mtaeProof }) => [
                            _createVNode(_component_v_list_item, {
                              disabled: !statusOk,
                              onClick: mtaeProof
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "small" }, {
                                  default: _withCtx(() => _cache[58] || (_cache[58] = [
                                    _createTextVNode("$oss-download")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[57] || (_cache[57] = [
                                    _createTextVNode("Imprimer le justificatif EDI")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"])
                          ]),
                          _: 1
                        }, 8, ["disabled", "taxFormId"]),
                        (_ctx.isSent && _ctx.isUserAuthorized && _ctx.xml)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 3,
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.downloadXMLFile()))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "small" }, {
                                  default: _withCtx(() => _cache[60] || (_cache[60] = [
                                    _createTextVNode("$oss-download")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[59] || (_cache[59] = [
                                    _createTextVNode("Télécharger le fichier XML")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_list_item, {
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.duplicate()))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "small" }, {
                              default: _withCtx(() => _cache[62] || (_cache[62] = [
                                _createTextVNode("$oss-duplicate")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[61] || (_cache[61] = [
                                _createTextVNode("Dupliquer")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, {
          "no-gutters": "",
          style: {"flex-wrap":"nowrap"}
        }, {
          default: _withCtx(() => [
            (_ctx.showLeftPanel)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "2",
                  class: "mr-2",
                  style: {"max-height":"calc(100vh - 164px)","overflow-y":"auto"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_v_tabs, {
                      key: _ctx.tabsRefreshKey,
                      direction: "vertical",
                      modelValue: _ctx.selectedTaxFormIndex,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectedTaxFormIndex) = $event)),
                      class: "mb-2 rounded-xl",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.loaded)
                          ? (_openBlock(), _createBlock(_component_v_tab, {
                              key: 0,
                              class: "d-flex justify-center align-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_progress_circular, {
                                  indeterminate: "",
                                  size: "28",
                                  color: "primary",
                                  class: "mx-auto"
                                })
                              ]),
                              _: 1
                            }))
                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.sheetNames, (name, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                (
                                _ctx.cerfaNumber === '2561' &&
                                !name.includes('2561BIS') &&
                                !name.includes('2561TER')
                            )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                      _createElementVNode("p", _hoisted_3, "Bénéficiaire " + _toDisplayString(index / 3 + 1), 1),
                                      (!_ctx.isSent)
                                        ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                            key: 0,
                                            size: "small",
                                            onClick: _withModifiers(($event: any) => (_ctx.openDialogToDeleteSheetForm(name, index)), ["stop"])
                                          }, null, 8, ["onClick"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_tab, {
                                  value: index,
                                  class: "d-flex align-center justify-space-between"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", null, _toDisplayString(name), 1),
                                    (_ctx.getShowTrashButton(name))
                                      ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                          key: 0,
                                          size: "small",
                                          onClick: _withModifiers(($event: any) => (_ctx.openDialogToDeleteSheetForm(name, index)), ["stop"])
                                        }, null, 8, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]),
                                (index < _ctx.sheetNames.length - 1 && name.includes('2561TER'))
                                  ? (_openBlock(), _createBlock(_component_v_divider, {
                                      key: 1,
                                      class: "mx-2 my-2"
                                    }))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 256)),
                        (_ctx.showAddFormButton)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              _createVNode(_component_v_btn, {
                                disabled: _ctx.isSent,
                                rounded: "",
                                size: "small",
                                elevation: "0",
                                block: "",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addFormDialog = true))
                              }, {
                                default: _withCtx(() => _cache[63] || (_cache[63] = [
                                  _createElementVNode("span", { class: "subtitle-1 white--text" }, "+", -1)
                                ])),
                                _: 1
                              }, 8, ["disabled"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.cerfaNumber === '2561')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createVNode(_component_v_btn, {
                                disabled: _ctx.isSent,
                                rounded: "",
                                size: "small",
                                elevation: "0",
                                block: "",
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addBeneficiary()))
                              }, {
                                default: _withCtx(() => _cache[64] || (_cache[64] = [
                                  _createTextVNode(" Ajouter un bénéficiaire ")
                                ])),
                                _: 1
                              }, 8, ["disabled"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])),
                    (_ctx.declaration)
                      ? (_openBlock(), _createBlock(_component_DeclarationManagerInfo, {
                          key: 0,
                          startDate: _ctx.startDate,
                          endDate: _ctx.endDate,
                          amountDeclared: _ctx.amountDeclared,
                          paymentsInfo: _ctx.paymentsInfo,
                          translatedStatus: _ctx.translatedStatus,
                          translatedSendDate: _ctx.translatedSendDate,
                          mtaeId: _ctx.mtaeId,
                          errors: _ctx.errors
                        }, null, 8, ["startDate", "endDate", "amountDeclared", "paymentsInfo", "translatedStatus", "translatedSendDate", "mtaeId", "errors"]))
                      : _createCommentVNode("", true),
                    (_ctx.cerfaNumber === '2561')
                      ? (_openBlock(), _createBlock(_component_DeclarationManagerDeclaring, {
                          key: 1,
                          declaring: _ctx.declaring,
                          isSent: _ctx.isSent,
                          onDeclaringHasBeenChanged: _cache[16] || (_cache[16] = ($event: any) => (_ctx.needSave = true))
                        }, null, 8, ["declaring", "isSent"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_v_btn, {
                        size: "small",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showLeftPanel = false))
                      }, {
                        default: _withCtx(() => _cache[65] || (_cache[65] = [
                          _createTextVNode("Masquer")
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_col, {
              cols: _ctx.showLeftPanel ? 10 : 12,
              class: "pa-0 flex-grow-1 flex-shrink-0 document-card",
              style: {"max-height":"calc(100vh - 164px)","overflow":"auto"}
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_component_v_window, {
                  modelValue: _ctx.selectedTaxFormIndex,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.selectedTaxFormIndex) = $event)),
                  key: _ctx.formsRefreshKey
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sheets, (sheet, index) => {
                      return (_openBlock(), _createBlock(_component_v_window_item, {
                        key: index,
                        value: index
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_TaxForm, {
                            ref_for: true,
                            ref: "taxForm",
                            cerfaNumber: sheet.cerfaNumber,
                            activeTab: _ctx.formDisplayMode,
                            sheet: sheet,
                            loaded: _ctx.loaded,
                            enableEdition: _ctx.enableEdition,
                            isSent: _ctx.isSent,
                            readOnly: _ctx.isSent,
                            onFieldUpdate: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onTaxFormChanged())),
                            onAdditionnalPageCreated: ($event: any) => (_ctx.additionnalPageCreated(index))
                          }, null, 8, ["cerfaNumber", "activeTab", "sheet", "loaded", "enableEdition", "isSent", "readOnly", "onAdditionnalPageCreated"])
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              ]),
              _: 1
            }, 8, ["cols"])
          ]),
          _: 1
        }),
        _createVNode(_component_oss_dialog, {
          modelValue: _ctx.confirmWithoutSendingDialog,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.confirmWithoutSendingDialog) = $event)),
          title: "Confirmation",
          onValid: _cache[21] || (_cache[21] = ($event: any) => (_ctx.validateWithoutSendingToMTAE())),
          validTitle: "Valider sans télédéclarer"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              style: {"width":"750px"},
              class: "text-center"
            }, {
              default: _withCtx(() => _cache[66] || (_cache[66] = [
                _createElementVNode("b", null, " Êtes-vous sûr(e) de vouloir valider la déclaration sans la télédéclarer ni la payer ? Les éventuelles écritures comptables seront générées automatiquement. ", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_oss_dialog, {
          modelValue: _ctx.confirmDialogSend,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.confirmDialogSend) = $event)),
          title: "Confirmation",
          onValid: _cache[25] || (_cache[25] = ($event: any) => (_ctx.generate())),
          validTitle: _ctx.validDeclarationTitle
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              style: {"width":"750px"},
              class: "text-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    (
                            _ctx.validAndPayTitle === _ctx.titleValidAndSend ||
                            _ctx.validAndPayTitle === _ctx.titleSendEDI
                        )
                      ? (_openBlock(), _createElementBlock("b", _hoisted_7, " Êtes-vous sûr(e) de vouloir envoyer la déclaration ? "))
                      : (_ctx.bankAccounts.length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_ctx.cerfaNumber === '1329AC' && _ctx.amountToPay <= 750)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _cache[67] || (_cache[67] = _createElementVNode("b", null, "Le montant est inférieur ou égal à 750 €, vous êtes dispensé de payer l'acompte, voulez-vous malgré tout réaliser un paiement ?", -1)),
                                  _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_v_checkbox, {
                                      dense: "",
                                      modelValue: _ctx.showPaymentsForExempt1329AC,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.showPaymentsForExempt1329AC) = $event)),
                                      label: "Envoyer un paiement",
                                      "hide-details": "auto"
                                    }, null, 8, ["modelValue"])
                                  ])
                                ], 64))
                              : _createCommentVNode("", true),
                            (
                                _ctx.cerfaNumber !== '1329AC' ||
                                (_ctx.cerfaNumber === '1329AC' && _ctx.amountToPay > 750) ||
                                _ctx.showPaymentsForExempt1329AC
                            )
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "mb-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("b", null, " Montant à payer : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.amountToPay, undefined)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "mb-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("b", null, [
                                        _cache[68] || (_cache[68] = _createTextVNode("Montant restant à répartir : ")),
                                        _createElementVNode("span", {
                                          style: _normalizeStyle(_ctx.unaffectedPaymentAmount < 0 ? 'color: red;' : '')
                                        }, _toDisplayString(_ctx.unaffectedPaymentAmount === 0
                                                ? _ctx.newCommonFormatCurrency(
                                                      _ctx.unaffectedPaymentAmount,
                                                      undefined,
                                                  )
                                                : _ctx.unaffectedPaymentAmount < 0
                                                  ? _ctx.unaffectedPaymentAmount +
                                                    ". Le montant du paiement ne peut pas être supérieur au montant dû."
                                                  : _ctx.unaffectedPaymentAmount), 5)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentsList, (line, index) => {
                                    return (_openBlock(), _createBlock(_component_v_row, {
                                      "no-gutters": "",
                                      key: index,
                                      class: "mb-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "1" }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "d-flex justify-center align-center pr-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_select_filled, {
                                              modelValue: line.bankAccountId,
                                              "onUpdate:modelValue": ($event: any) => ((line.bankAccountId) = $event),
                                              items: _ctx.bankAccounts,
                                              "item-title": "name",
                                              "item-value": "id",
                                              "item-disabled": _ctx.isItemDisabled,
                                              outlined: "",
                                              class: "text-field",
                                              "hide-details": "auto",
                                              required: "",
                                              label: "Compte bancaire",
                                              density: "compact"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-disabled"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          class: "d-flex justify-center align-center pl-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_oss_text_field_filled, {
                                              modelValue: line.amount,
                                              "onUpdate:modelValue": ($event: any) => ((line.amount) = $event),
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                              label: "Montant"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "2",
                                          class: "d-flex"
                                        }, {
                                          default: _withCtx(() => [
                                            (index > 0)
                                              ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                                  key: 0,
                                                  class: "mx-2 my-2",
                                                  onClick: ($event: any) => (_ctx.deletePaymentLine(index)),
                                                  size: "x-small"
                                                }, null, 8, ["onClick"]))
                                              : _createCommentVNode("", true),
                                            (index === _ctx.paymentsList.length - 1)
                                              ? (_openBlock(), _createBlock(_component_v_btn_add_icon, {
                                                  key: 1,
                                                  class: "mx-2 my-2",
                                                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.addPaymentLine())),
                                                  disabled: 
                                            !line.amount ||
                                            !line.bankAccountId ||
                                            _ctx.paymentsList.length === _ctx.bankAccounts.length
                                        ,
                                                  size: "x-small"
                                                }, null, 8, ["disabled"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "pt-4"
                                        }, {
                                          default: _withCtx(() => [
                                            (!line.bankAccountId)
                                              ? (_openBlock(), _createElementBlock("b", _hoisted_9, " Envoi d'un paiement impossible car aucun compte bancaire sélectionné dans la liste. L'envoi de la déclaration seule reste possible. "))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock("b", _hoisted_10, " Envoi d'un paiement impossible car aucun compte bancaire valide renseigné dans le dossier. L'envoi de la déclaration seule reste possible. "))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "validTitle"]),
        _createVNode(_component_oss_dialog, {
          modelValue: _ctx.confirmDialogMiscellaneousOperation,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.confirmDialogMiscellaneousOperation) = $event)),
          title: "Modification OD",
          onValid: _cache[27] || (_cache[27] = ($event: any) => (_ctx.confirm())),
          validTitle: 'OK'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              style: {"width":"750px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "d-flex justify-center"
                }, {
                  default: _withCtx(() => _cache[69] || (_cache[69] = [
                    _createElementVNode("div", { class: "pt-2 px-4 pb-2" }, " Si vous modifiez l'écriture manuellement, vous perdrez le lien entre la déclaration et l'OD. ", -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_oss_dialog, {
          modelValue: _ctx.miscellaneousOperationDialog,
          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.miscellaneousOperationDialog) = $event)),
          actions: _ctx.actionsMiscellaneousOperation,
          onValid: _cache[29] || (_cache[29] = ($event: any) => (_ctx.miscellaneousOperationDialog = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              (_ctx.miscellaneousOperationDialog)
                ? (_openBlock(), _createBlock(_component_AccountingItemEdition, {
                    key: 0,
                    companyId: _ctx.companyId,
                    documentId: _ctx.newDocumentId || _ctx.documentId,
                    actions: _ctx.actionsMiscellaneousOperation
                  }, null, 8, ["companyId", "documentId", "actions"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "actions"]),
        _createVNode(_component_oss_dialog, {
          modelValue: _ctx.addFormDialog,
          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.addFormDialog) = $event)),
          title: "Ajouter un formulaire à la déclaration"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "py-1",
              style: {"width":"750px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.searchForm,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.searchForm) = $event)),
                      label: "Rechercher",
                      outlined: "",
                      "hide-details": "",
                      density: "compact",
                      "append-inner-icon": "$search",
                      clearable: "",
                      "onClick:clear": _cache[31] || (_cache[31] = ($event: any) => (_ctx.searchForm = ''))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  style: {"max-height":"calc(100vh - 200px)","overflow-y":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, { "two-lines": "" }, {
                      default: _withCtx(() => [
                        (_ctx.filteredOptionalForms.length)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filteredOptionalForms, (form, index) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: index,
                                onClick: ($event: any) => (_ctx.formToAdd(form)),
                                "two-lines": "",
                                disabled: _ctx.shortSheetNames.includes(form.cerfa.slice(0, 5))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(form.cerfa), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_list_item_subtitle, { style: {"white-space":"break-spaces"} }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(form.title), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "disabled"]))
                            }), 128))
                          : (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 1,
                              "two-lines": ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[70] || (_cache[70] = [
                                    _createTextVNode("Aucun formulaire trouvé")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (_ctx.toDeleteDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 0,
              modelValue: _ctx.toDeleteDialog,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.toDeleteDialog) = $event)),
              title: "Suppression formulaire(s)",
              onValid: _cache[34] || (_cache[34] = ($event: any) => (_ctx.deleteSheet()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.deleteSheetTitle), 1)
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.ibanLimitDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 1,
              modelValue: _ctx.ibanLimitDialog,
              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.ibanLimitDialog) = $event)),
              title: "Limite DGFIP",
              onValid: _cache[36] || (_cache[36] = ($event: any) => (_ctx.ibanLimitDialog = false)),
              validTitle: 'OK'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "pt-3 text-center",
                  style: {"width":"750px"}
                }, {
                  default: _withCtx(() => _cache[71] || (_cache[71] = [
                    _createElementVNode("p", null, " La DGFIP fixe le nombre de comptes bancaires maximal à trois pour les paiements. ", -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.autoDepositValidationDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 2,
              modelValue: _ctx.autoDepositValidationDialog,
              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.autoDepositValidationDialog) = $event)),
              onValid: _cache[38] || (_cache[38] = ($event: any) => (_ctx.fillAutoDepositInDeclaration())),
              onClose: _cache[39] || (_cache[39] = ($event: any) => (_ctx.autoDepositValidationDialog = false)),
              validTitle: "Appliquer"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "pa-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "d-flex align-center justify-center"
                      }, {
                        default: _withCtx(() => _cache[72] || (_cache[72] = [
                          _createElementVNode("b", { class: "text-center" }, " bobbee a trouvé le montant de l'acompte à déclarer. Souhaitez-vous alimenter automatiquement le formulaire? ", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createVNode(_component_oss_dialog, {
          modelValue: _ctx.infoMillesimDialog,
          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.infoMillesimDialog) = $event)),
          title: "Millésime",
          onValid: _cache[41] || (_cache[41] = ($event: any) => (_ctx.infoMillesimDialog = false)),
          validTitle: "OK"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              style: {"width":"750px"},
              class: "d-flex justify-center"
            }, {
              default: _withCtx(() => _cache[73] || (_cache[73] = [
                _createTextVNode(" Pour information, le millésime utilisé pour cette déclaration est celui de 2024. ")
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_oss_dialog, {
          modelValue: _ctx.declaringAlertDialog,
          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.declaringAlertDialog) = $event)),
          title: "Déclarant",
          onValid: _cache[43] || (_cache[43] = ($event: any) => (_ctx.declaringAlertDialog = false)),
          validTitle: "OK"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              style: {"width":"750px"},
              class: "d-flex justify-center"
            }, {
              default: _withCtx(() => _cache[74] || (_cache[74] = [
                _createTextVNode(" Veuillez remplir les informations déclarant pour envoyer la déclaration. ")
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 2))
    : _createCommentVNode("", true)
}